import { render, staticRenderFns } from "./ReportBmdExportSums.vue?vue&type=template&id=2b26c2ad&scoped=true&"
import script from "./ReportBmdExportSums.vue?vue&type=script&lang=js&"
export * from "./ReportBmdExportSums.vue?vue&type=script&lang=js&"
import style0 from "./ReportBmdExportSums.vue?vue&type=style&index=0&id=2b26c2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b26c2ad",
  null
  
)

export default component.exports